import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '../router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    BASE_URI: 'https://loyalty.pakomak.com.mk/api/',
    // BASE_URI: 'https://ecomak.pakomak.mk/api/',
    // BASE_URI: 'http://214.237.165.211:8000/api/',
    // BASE_URI: 'http://localhost:85/',
    EXTENSION_DEV_URL: 'https://localhost:7176/',
    EXTENSION_TEST_URL: 'http://214.237.165.211:8000/QR/',
    EXTENSION_PROD_URL: 'https://loyalty.pakomak.com.mk/QR/', //PROD
    ENV: 'PROD',
    accessToken: null,
    loggingIn: false,
    loginError: null,
    users: [],
  },
  mutations: {
    loginStart: (state) => state.loggingIn = true,
    loginStop: (state, errorMessage) => {
      state.loggingIn = false;
      state.loginError = errorMessage;
    },
    updateAccessToken: (state, accessToken) => {
      state.accessToken = accessToken;
    },
    logout: (state) => {
      state.accessToken = null;
    },
    initUsers(state, users) {
      state.users = users;
    },
  },
  actions: {
    doLogin({ commit }, loginData) {
      commit('loginStart');

      axios.post(this.state.BASE_URI + 'admin/auth/login', {
        ...loginData,
      })
        .then((response) => {
          localStorage.setItem('accessToken', response.data.token);
          commit('loginStop', null);
          commit('updateAccessToken', response.data.token);
          if (response.data.token) {
            router.push('/home');
          } else {
            commit('loginStop', response.data.error);
            commit('updateAccessToken', null);
          }

        })
        .catch((error) => {
          commit('loginStop', error.response.data.error);
          commit('updateAccessToken', null);
        });
    },
    fetchAccessToken({ commit }) {
      commit('updateAccessToken', localStorage.getItem('accessToken'));
    },
    logout({ commit }) {
      localStorage.removeItem('accessToken');
      commit('logout');
      router.push('/login');
    },
    fetchUsers(context) {
      axios.get(this.state.BASE_URI + 'admin/users/all_users', { headers: { Authorization: localStorage.getItem('accessToken') } })
        .then((response) => {
          context.commit('initUsers', JSON.parse(response.data.users));


        })
        .catch((error) => {
          if (error.response.status === 401) {
            localStorage.removeItem('accessToken');
            context.commit('logout');
            router.push('/login');
          }
        });
    },


  },
  modules: {
  },
  getters: {
    getUsers(state) {
      return state.users;
    },
    getExtensionURL(state) {
      if (state.ENV === 'dev') {
        return state.EXTENSION_DEV_URL;
      } else if (state.ENV === 'test') {
        return state.EXTENSION_TEST_URL;
      } else if (state.ENV === 'PROD') {
        return state.EXTENSION_PROD_URL;
      } else {
        return 'NO URL';
      }
    },
  },
});


